import { z } from '../zod';
import { ObjectIdStringValidationSchema } from '../shared/ObjectId';
import {
  OrderBumpShowHideComparisonValidationSchema,
  OrderBumpShowHideSubjectValidationSchema,
} from './enum';

export const OrderBumpShowHideLogicInputValidationSchema = z
  .object({
    enabled: z.boolean().meta({
      description:
        'Whether the rule is on. Off, the order bump shows regardless of the fields below.',
    }),
    subject: OrderBumpShowHideSubjectValidationSchema.optional().meta({
      description:
        'What the rule watches. Defaults to `price` on a checkout page and `ticket` on an event.',
    }),
    comparison: OrderBumpShowHideComparisonValidationSchema.optional().meta({
      description: 'Defaults to `is`.',
    }),
    priceIds: z.array(ObjectIdStringValidationSchema).optional().meta({
      description:
        'For `subject: price`: the page product price IDs to watch (from get_product). The rule matches while the chosen price is any of them, or none of them for `is_not`. A rule without any is stored but never hides anything.',
    }),
    ticketTypeIds: z.array(ObjectIdStringValidationSchema).optional().meta({
      description:
        'For `subject: ticket`: the ticket type IDs to watch. The rule matches while any of them is in the basket.',
    }),
    orderBumpProductIds: z.array(ObjectIdStringValidationSchema).optional().meta({
      description:
        "For `subject: order_bump`: product IDs of other order bumps on the same page. The rule matches while any of them is ticked. The order bump's own ID is ignored.",
    }),
  })
  .meta({
    description:
      'Rule that shows the order bump only for some selections. Sent whole: it replaces the stored rule.',
  });

export const orderBumpSettingsInputFields = {
  enabled: z.boolean().optional().meta({
    description:
      'Whether the order bump is offered. A disabled order bump stays on the page but is not shown.',
  }),
  preselected: z.boolean().optional().meta({
    description: 'Whether the order bump is ticked when the page loads.',
  }),
  hidden: z.boolean().optional().meta({
    description:
      'Hide the order bump unless the page URL reveals it with `?show_order_bumps=` and the product price reference.',
  }),
  showHideLogic: OrderBumpShowHideLogicInputValidationSchema.optional(),
  allowQuantity: z.boolean().optional().meta({
    description: 'Let the customer pick a quantity. Off, the order bump is bought once.',
  }),
  shortenDescription: z.boolean().optional().meta({
    description: 'Clamp a long description behind a Show more toggle.',
  }),
};
